<template>
  <div
    class="flex items-start gap-2.5 rounded-md border border-gray-200 border-l-[3px] bg-white px-3 py-2.5 text-sm leading-normal text-gray-500"
    :class="tones.edge"
  >
    <!--
      The ONE notice pattern of prototype v3: a white card, a 3 px coloured left
      edge and a coloured icon. design-spec §17.1 — "colour is a left edge, an
      icon or a number. Never a fill." PrimeVue `Message` tints the whole box,
      which is exactly what v2 was re-skinned to undo, so it is not used here.
      (Comments stay INSIDE the root: one before it makes the component a
      fragment in dev builds, and class / data-testid would not land.)
    -->
    <span
      v-if="icon"
      class="pi mt-0.5 shrink-0 text-sm"
      :class="[icon, tones.icon]"
      aria-hidden="true"
    ></span>
    <div class="min-w-0 flex-1">
      <slot />
    </div>
    <slot name="action" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

/**
 * RED-351 rework — prototype v3's `.notice`, used for the file-ready line, the
 * BETA note, the expiry line, the waiting note and the checklist note.
 */
const props = defineProps({
  /** neutral | info | warn | error | success */
  tone: { type: String, default: 'neutral' },
  /** A PrimeIcons class, e.g. `pi-info-circle`. */
  icon: { type: String, default: '' },
})

const TONES = {
  neutral: { edge: 'border-l-gray-400', icon: 'text-gray-500' },
  info: { edge: 'border-l-blue-500', icon: 'text-blue-500' },
  warn: { edge: 'border-l-amber-500', icon: 'text-amber-500' },
  error: { edge: 'border-l-red-500', icon: 'text-red-500' },
  success: { edge: 'border-l-emerald-500', icon: 'text-emerald-500' },
}

const tones = computed(() => TONES[props.tone] ?? TONES.neutral)
</script>
